'use client';
export default function VideoSection() {
  return (
    <section id="video-1" className="wide-60">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* TEXT */}
          <div className="w-full lg:w-1/2">
            <span className="block text-xs font-bold uppercase tracking-widest mb-3" style={{ color: '#0e5932' }}>
              Notre Vision & Mission
            </span>
            <h3 className="text-3xl md:text-4xl font-black mb-8" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
              Transformer le Paysage des Soins de Santé en Côte d'Ivoire
            </h3>

            {[
            'Vision : Devenir le leader incontesté des soins de santé en Côte d\'Ivoire, offrant une expérience médicale alliant excellence, accessibilité et esthétisme.',
            'Mission : Un plateau technique de pointe et une qualité de soins dans un cadre soigné, pour élever les standards de santé en Côte d\'Ivoire et à travers toute l\'Afrique.',
            'Le projet COSA a pour objectif de transformer le paysage des soins de santé en créant un réseau de centres médicaux d\'excellence, accessibles à tous et conformes aux meilleures pratiques internationales.']?.
            map((text, i) =>
            <div key={i} className="flex items-start gap-3 mb-4">
                <i className="fas fa-genderless mt-1 flex-shrink-0" style={{ color: '#0e5932' }}></i>
                <p className="text-sm text-gray-600 m-0">{text}</p>
              </div>
            )}
          </div>

          {/* VIDEO PREVIEW */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl cursor-pointer group">
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_13d14d7d9-1766083991800.png"
                alt="Équipe médicale africaine dans une salle d'opération moderne avec des équipements avancés"
                className="w-full object-cover"
                style={{ height: '380px' }} />
              
              <div className="absolute inset-0 flex items-center justify-center" style={{ background: 'rgba(14,89,50,0.4)' }}>
                <a
                  href="https://www.youtube.com/embed/SZEflIVnhH8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-20 h-20 rounded-full flex items-center justify-center text-white text-2xl transition-all group-hover:scale-110"
                  style={{ backgroundColor: '#0e5932' }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fbaf45'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#0e5932'}
                  aria-label="Lire la vidéo">
                  <i className="fas fa-play ml-1"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}